export default {
  en: {
    addTo: 'Add to Google preferred sources',
    shareTo: 'Share to',
    Email: 'Email',
    Print: 'Print',
    Share: 'Share',
    Tweet: 'Tweet',
    Pin: 'Pin',
  },
  es: {
    addTo: 'Aregar a Google fuentes preferidas',
    shareTo: 'Compartir con',
    Email: 'Email',
    Print: 'Imprimir',
    Share: 'Compartir',
    Tweet: 'Tweet',
    Pin: 'Pin',
  },
  pt: {
    addTo: 'Adicionar à Google fontes preferenciais',
    shareTo: 'Compartilhe no',
    Email: 'E-mail',
    Print: 'Imprimir',
    Share: 'Compartilhe',
    Tweet: 'Compartilhe',
    Pin: 'Salve',
  },
};
